import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-countdown', 'days', 'Dienos');
Labels.set('ui-countdown', 'hours', 'Valandų');
Labels.set('ui-countdown', 'minutes', 'Minučių');
Labels.set('ui-countdown', 'seconds', 'Sekundžių');
